<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form   label-width="140px" label-position="left">
          <el-form-item label="专题分类选择:">
            <el-select v-model="syminfo" filterable placeholder="请选择专题类别" @change="symtypechange">
              <el-option
                v-for="item in symtypes"
                :key="item.id.Int64"
                :label="item.typename.String"
                :value="item.id.Int64"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button style="margin-top: 10px" @click="editzttype">编辑专题分类</el-button>
          <el-button style="margin-top: 10px" @click="addnewzt">添加新专题</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        :data="splist"
        ref="multipleTable">
        <el-table-column
          prop="title.String"
          width = "200px"
          label="标题名称">
        </el-table-column>
        <el-table-column
          prop="subtitle.String"
          label="子标题">
        </el-table-column>
        <el-table-column
          width = "300px"
          prop="ossurl.String"
          label="缩略图地址">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑该专题" placement="top-start">
              <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="editzt(scope.$index, splist)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="移除该专题" placement="top-start">
              <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="removezt(scope.$index, splist)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog title="添加专题" :visible.sync="visztinfo">
      <div class="showpcinfo">
        <el-form  label-width="150px">
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="标题:">
                  <el-input v-model="newtitle" placeholder="请输入标题"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="子标题:" style="margin-left: 20px;">
                  <el-input v-model="newsubtitle" placeholder="请输入子标题"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="简介:" >
                  <el-input v-model="newdes" placeholder="请输入简要描述"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px"  label-position="left">
                <el-form-item label="是否放置首页:">
                  <el-select v-model="iffzsyinfo" filterable placeholder="请选择是否放置于首页">
                    <el-option
                      v-for="item in iffzsy"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px"  label-position="left">
                <el-form-item label="链接类别:">
                  <el-select v-model="linktype" filterable placeholder="请选择链接的类别" @change="linktypechange">
                    <el-option
                      v-for="item in linktypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="缩略图:" >
                  <el-upload
                    class="avatar-uploader"
                    drag
                    action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                    :data="{'bucketname':'sqwebsite','bucketpath':'article'}"
                    :on-success="OnUpFileZTSuccess"
                    :on-error="OnUpFileZTError"
                    :before-upload="BeforeUpFileZTUpload">
                    <img v-if="wsimgurlok" :src="wsimgurl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="图片路径:" >
                  <el-input v-model="osspathinfo" placeholder="请输入简要描述"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="链接地址:" >
                  <el-input v-model="linkpathinfo" placeholder="请输入简要描述"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <div v-show="vislinkcontext" >
              <el-col :span="24">
                <el-form   label-width="120px" label-position="left">
                  <el-form-item label="链接内容:" >
                    <el-table
                      stripe
                      :data="articles"
                      highlight-current-row
                      @current-change="selecturl"
                      ref="sympagelisttb">
                      <el-table-column
                        prop="title.String"
                        width = "480px"
                        label="标题名称">
                      </el-table-column>
                      <el-table-column
                        prop="subtitle.String"
                        label="子标题">
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </el-row>
          <el-row class="querypanel">
            <el-button @click="addztcontext">添加专题信息</el-button>
            <el-button @click="upztcontext">更新专题信息</el-button>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="编辑专题分类" :visible.sync="viszttype">
      <el-row class="querypanel">
        <el-col :span="12">
          <el-form   label-width="140px" label-position="left">
            <el-form-item label="分类名称:">
              <el-input v-model="spltypename" placeholder="请输入新专题分类名称"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
            <el-button style="margin-left: 20px" @click="addspltype">新增专题分类</el-button>
        </el-col>
      </el-row>
      <el-table
        stripe
        :data="symtypes"
        ref="multipleTable">
        <el-table-column
          prop="typename.String"
          label="分类名称">
        </el-table-column>
        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="移除该专题" placement="top-start">
              <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="removezttype(scope.$index, symtypes)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import ElDialog from '../../../node_modules/element-ui/packages/dialog/src/component'
Vue.prototype.$http = axios
var that
// 域名地址
const DOMAIN_URL = 'http://www.sqnetsoft.cn'
// 专题相对地址
const SYMPOSIUM_URL = '/articlelist.html'
// 文章相对地址
const ARTICLE_URL = '/article.html'
export default {
  components: {ElDialog},
  name: 'SymPosiumList',
  data () {
    return {
      symdata: [],
      viszttype: false,
      visztinfo: false,
      vislinkcontext: false,
      wsimgurlok: false,
      wsimgurl: '',
      spltypename: '',
      iffzsyinfo: '1',
      iffzsy: [{
        value: '1',
        label: '放置'
      }, {
        value: '2',
        label: '不放置'
      }],
      linktype: '',
      linktypes: [{
        value: '1',
        label: '分类'
      }, {
        value: '2',
        label: '文章'
      }],
      upztpath: '',
      syminfo: '',
      newtitle: '',
      newsubtitle: '',
      sympagelistdata: [],
      osspathinfo: '',
      linkpathinfo: '',
      newdes: '',
      khid: '',
      selectzt: ''
    }
  },
  computed: {
    symtypes () {
      return this.$store.state.website.sptypes
    },
    addstate () {
      return this.$store.state.website.addstate
    },
    delstate () {
      return this.$store.state.website.delstate
    },
    splist () {
      return this.$store.state.website.spobjs
    },
    articles () {
      return this.$store.state.website.articles
    }
  },
  mounted: function () {
    that = this
    this.khid = getCookie('cusid')
    this.$store.commit('website/setcusid', {
      'cusid': this.khid
    })
    this.$store.dispatch('website/getsptypes')
  },
  methods: {
    // 链接方式改变后触发 （已更新）
    linktypechange () {
      console.log(this.linktype)
      if (this.linktype === '1') {
        // 链接方式为分类
        this.vislinkcontext = false
        // 设定分类对应的链接
        this.linkpathinfo = DOMAIN_URL + SYMPOSIUM_URL + '?pageid=' + this.syminfo
      } else if (this.linktype === '2') {
        // 链接方式为文章
        this.vislinkcontext = true
        // 读取分类文章的内容
        var qstr1 = 'type =' + that.syminfo
        var loadarticleobj = {
          whereinfo: {String: qstr1, Valid: true}
        }
        this.$store.commit('website/setqueryarticleobj', {
          'queryarticleobj': loadarticleobj
        })
        this.$store.dispatch('website/getarticlelist')
      }
    },
    // 增加专题分类 （已更新）
    addspltype () {
      var insertdata = {
        typename: {String: this.spltypename, Valid: true},
        cusid: parseInt(that.khid)
      }
      this.$store.commit('website/setsptypeobj', {
        'sptypeobj': insertdata
      })
      this.$store.dispatch('website/addsptypes', {
        success () {
          that.$message({
            type: 'success',
            message: '添加完毕!'
          })
        }
      })
    },
    // 编辑专题分类 （已更新）
    editzttype () {
      this.viszttype = true
      this.$store.commit('website/setcusid', {
        'cusid': this.khid
      })
      this.$store.dispatch('website/getsptypes')
    },
    // 设置文章链接 （已更新）
    selecturl (val) {
      console.log(val)
      this.linkpathinfo = DOMAIN_URL + ARTICLE_URL + '?pageid=' + val.id.Int64
    },
    // 上传成功时触发 （无需更新）
    OnUpFileZTSuccess (res, file, fileList) {
      if (res.success) {
        this.upztpath = res.data[0].osspath
        this.osspathinfo = res.data[0].osspath
      }
    },
    // 删除失败时触发
    OnUpFileZTError () {},
    // 上传前触发
    BeforeUpFileZTUpload () {},
    // 显示专题列表 （已更新）
    symtypechange () {
      console.log('显示专题列表')
      // 更改专题分类以后，显示对应的专题列表
      var qztstr = {
        whereinfo: {String: 'type =' + that.syminfo + ' and parentid = -1', Valid: true},
        sorinfo: {String: 'order by LENGTH(ossurl), ossurl', Valid: true}
      }
      console.log(qztstr)
      this.$store.commit('website/setqueryspobj', {
        'queryspobj': qztstr
      })
      this.$store.dispatch('website/getsplist')
    },
    // 编辑专题 （已更新）
    editzt (index, data) {
      this.visztinfo = true
      console.log(data[index])
      this.selectzt = data[index]
      this.iffzsyinfo = this.selectzt.iffzsy.Int64.toString()
      this.newtitle = this.selectzt.title.String
      this.newsubtitle = this.selectzt.subtitle.String
      this.newdes = this.selectzt.context.String
      this.osspathinfo = this.selectzt.ossurl.String
      this.linkpathinfo = this.selectzt.linkurl.String
      if (this.selectzt.ossurl.Valid) {
        this.wsimgurlok = true
        this.wsimgurl = this.selectzt.ossurl.String
      }
    },
    // 删除专题分类 （已更新）
    removezttype (index, data) {
      var selectdata = data[index]
      var deldata = {
        whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
      }
      this.$store.commit('website/setsptypeobj', {
        'sptypeobj': deldata
      })
      this.$store.dispatch('website/delsptypes', {
        success () {
          that.$message({
            type: 'success',
            message: '删除完毕!'
          })
        }
      })
    },
    // 打开新增专题窗口
    addnewzt () {
      console.log('增加新专题')
      // 显示新增专题页面
      this.visztinfo = true
      // 清空原有数据
      that.newtitle = ''
      that.linktype = ''
      that.newsubtitle = ''
      that.newdes = ''
      that.osspathinfo = ''
      that.iffzsyinfo = '2'
      this.linkpathinfo = ''
      var qstr1 = 'type =' + that.syminfo
      var loadarticleobj = {
        whereinfo: {String: qstr1, Valid: true}
      }
      this.$store.commit('website/setqueryarticleobj', {
        'queryarticleobj': loadarticleobj
      })
      this.$store.dispatch('website/getarticlelist')
    },
    // 增加新专题 （已更新）
    addztcontext () {
      var adddata = {
        type: parseInt(that.syminfo),
        title: {String: that.newtitle, Valid: true},
        subtitle: {String: this.newsubtitle, Valid: true},
        context: {String: this.newdes, Valid: true},
        ossurl: {String: this.osspathinfo, Valid: true},
        iffzsy: {Int64: parseInt(this.iffzsyinfo), Valid: true},
        linkurl: {String: this.linkpathinfo, Valid: true},
        tjindex: {Int64: parseInt(-1), Valid: true},
        parentid: parseInt(-1),
        haschild: parseInt(1),
        level: parseInt(1),
        cusid: parseInt(that.khid)
      }
      this.$store.commit('website/setspobj', {
        'spobj': adddata
      })
      this.$store.dispatch('website/addsp', {
        success () {
          that.$message({
            type: 'success',
            message: '添加完毕!'
          })
          var qztstr = {
            whereinfo: {String: 'type =' + that.syminfo + ' and parentid = -1', Valid: true},
            sorinfo: {String: 'order by LENGTH(ossurl), ossurl', Valid: true}
          }
          this.$store.commit('website/setqueryspobj', {
            'queryspobj': qztstr
          })
        }
      })
    },
    // 更新专题内容 （已更新）
    upztcontext () {
      console.log('更新专题信息')
      var adddata = {
        id: {Int64: parseInt(this.selectzt.id.Int64), Valid: true},
        type: parseInt(that.syminfo),
        title: {String: that.newtitle, Valid: true},
        subtitle: {String: this.newsubtitle, Valid: true},
        context: {String: this.newdes, Valid: true},
        ossurl: {String: this.osspathinfo, Valid: true},
        iffzsy: {Int64: parseInt(this.iffzsyinfo), Valid: true},
        linkurl: {String: this.linkpathinfo, Valid: true},
        tjindex: {Int64: parseInt(-1), Valid: true},
        parentid: parseInt(-1),
        haschild: parseInt(1),
        level: parseInt(1),
        cusid: parseInt(that.khid)
      }
      this.$store.commit('website/setspobj', {
        'spobj': adddata
      })
      this.$store.dispatch('website/addsp', {
        success () {
          that.$message({
            type: 'success',
            message: '添加完毕!'
          })
          var qztstr = {
            whereinfo: {String: 'type =' + that.syminfo + ' and parentid = -1', Valid: true},
            sorinfo: {String: 'order by LENGTH(ossurl), ossurl', Valid: true}
          }
          this.$store.commit('website/setqueryspobj', {
            'queryspobj': qztstr
          })
        }
      })
    },
    // 删除专题 (已更新)
    removezt (index, data) {
      var selectdata = data[index]
      var delzt = {
        whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
      }
      this.$store.commit('website/setspobj', {
        'spobj': delzt
      })
      var qztstr = {
        whereinfo: {String: 'type =' + that.syminfo + ' and parentid = -1', Valid: true},
        sorinfo: {String: 'order by LENGTH(ossurl), ossurl', Valid: true}
      }
      this.$store.commit('website/setqueryspobj', {
        'queryspobj': qztstr
      })
      this.$store.dispatch('website/delsp', {
        success () {
          that.$message({
            type: 'success',
            message: '删除完毕!'
          })
        }
      })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/website/SymPosiumList.vue